import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { Image } from "hesus-ui-kit";
import * as moment from "moment";
import { handleApiError } from "@utils/errorHandler";
import SolutionView from "../../../SolutionView/SolutionView";
import AddEditSolution from "../../../AddEditSolution";
import { SolutionIdContainer, IDButton } from "./SolutionId.styled";
import { DivBackgroundOpacity } from "@utils/extra-style";
import { countryInfoById } from "@hooks/useGeneralParams";
import acceptanceGrey from "@icons/acceptance-grey.svg";
import acceptanceOrange from "@icons/acceptance-orange.svg";
import acceptanceGreen from "@icons/acceptance-green.svg";
import SolutionAcceptanceView from "../../../../SolutionAcceptance/SolutionAcceptanceView";
import AddEditSolutionAcceptance from "../../../../SolutionAcceptance/AddEditSolutionAcceptance";

const SolutionId = (props) => {
  const {
    t,
    data,
    onRefreshData,
    isEditBtnVisible,
    enquiryService,
    enquirySubCategoryName,
    enquirySubCategoryId,
    enquiryId,
    countryId,
  } = props;

  const [currentSolution, setCurrentSolution] = useState(null);
  const [isAddSolutionPopupVisible, setAddSolutionPopupVisibility] =
    useState(false);
  const [isSolutionViewPopupVisible, setSolutionViewPopupVisibility] =
    useState(false);
  const [isViewSolutionAcceptancePopUp, setViewSolutionAcceptancePopUp] =
    useState(false);
  const [isAddEditSolutionAcceptancePopUp, setAddEditSolutionAcceptancePopUp] =
    useState(false);
  const [acceptanceSolutionId, setAcceptanceSolutionId] = useState("");
  const [centreName, setCentreName] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [isEditSolutionAcceptancePopUp, setEditSolutionAcceptancePopUp] =
    useState(false);
  const [isAddSolutionAcceptanceInPopUp, setAddSolutionAcceptanceInPopUp] =
    useState(false);
  const [acceptanceId, setAcceptanceId] = useState("");

  const countryInfo = countryInfoById(countryId);

  const momentDate = moment(new Date()).format("YYYY-MM-DD");
  const currentDate = new Date(momentDate).getTime();

  const onSolutionIdClick = () => {
    setSolutionViewPopupVisibility(true);
  };

  const onSolutionViewClose = () => {
    setSolutionViewPopupVisibility(false);
  };

  const closeSolutionEditPopup = () => {
    setAddSolutionPopupVisibility(false);
    onRefreshData(true);
  };

  const editSolution = () => {
    setSolutionViewPopupVisibility(false);
    axios
      .get(`/solutions/${data.id}`)
      .then((response) => {
        setCurrentSolution(response.data[0]);
        setAddSolutionPopupVisibility(true);
      })
      .catch((error) => handleApiError(error));
  };

  useEffect(() => {
    onRefreshData(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAcceptanceInfo = (acceptanceInfo) => {
    let acceptanceIcon = acceptanceOrange;
    acceptanceInfo.map((acceptance) => {
      const validityStartDate = new Date(acceptance.validityStart).getTime();
      const validityEndDate = new Date(acceptance.validityEnd).getTime();
      if (
        acceptance.isActive === 1 &&
        parseInt(validityEndDate, 10) >= parseInt(currentDate, 10) &&
        parseInt(currentDate, 10) >= parseInt(validityStartDate, 10)
      ) {
        acceptanceIcon = acceptanceGreen;
      }
    });
    return acceptanceIcon;
  };

  const getAcceptanceText = (acceptanceInfo) => {
    let acceptanceText = t("SOLUTION_ACCEPTANCE_NOT_VALID_TOOLTIP");
    acceptanceInfo.map((acceptance) => {
      const validityStartDate = new Date(acceptance.validityStart).getTime();
      const validityEndDate = new Date(acceptance.validityEnd).getTime();
      if (
        acceptance.isActive === 1 &&
        parseInt(validityEndDate, 10) >= parseInt(currentDate, 10) &&
        parseInt(currentDate, 10) >= parseInt(validityStartDate, 10)
      ) {
        acceptanceText = t("SOLUTION_ACCEPTANCE_VALID_TOOLTIP");
      }
    });
    return acceptanceText;
  };

  const onSolutionAcceptanceClick = (id, centreInfo) => {
    setAcceptanceSolutionId(id);
    setSupplierName(centreInfo?.supplierName);
    setCentreName(centreInfo?.companyName);
    setViewSolutionAcceptancePopUp(true);
  };

  const onCloseAcceptanceView = () => {
    setAcceptanceSolutionId("");
    setSupplierName("");
    setCentreName("");
    setViewSolutionAcceptancePopUp(false);
    onRefreshData(true);
  };

  const onSolutionAddEditAcceptanceClick = (id, centreInfo) => {
    setAcceptanceSolutionId(id);
    setSupplierName(centreInfo?.supplierName);
    setCentreName(centreInfo?.companyName);
    setAddEditSolutionAcceptancePopUp(true);
  };

  const onCloseAddEditAcceptanceView = () => {
    setAcceptanceSolutionId("");
    setSupplierName("");
    setCentreName("");
    setAddEditSolutionAcceptancePopUp(false);
  };

  const onSolutionEditAcceptanceClick = () => {
    setViewSolutionAcceptancePopUp(false);
    setEditSolutionAcceptancePopUp(true);
  };

  const onCloseEditAcceptanceView = () => {
    setEditSolutionAcceptancePopUp(false);
    setViewSolutionAcceptancePopUp(true);
  };

  const onSolutionAddAcceptanceClick = () => {
    setViewSolutionAcceptancePopUp(false);
    setAddEditSolutionAcceptancePopUp(true);
    setAddSolutionAcceptanceInPopUp(true);
  };

  const onCloseAddAcceptanceView = () => {
    setAddEditSolutionAcceptancePopUp(false);
    setViewSolutionAcceptancePopUp(true);
    setAddSolutionAcceptanceInPopUp(false);
  };

  return (
    <SolutionIdContainer>
      <DivBackgroundOpacity
        opacity={data?.isActive === 1 ? 1 : "0.2"}
        display="flex"
      >
        {!!countryInfo?.needSolutionAcceptance && (
          <div style={{ width: "30px" }}>
            {data?.acceptances?.length === 0 &&
              parseInt(data?.statusId, 10) === 7 && (
                <Image
                  className="deleteImage"
                  src={acceptanceGrey}
                  alt={t("SOLUTION_NO_ACCEPTANCE_TOOLTIP")}
                  title={t("SOLUTION_NO_ACCEPTANCE_TOOLTIP")}
                  styles={{
                    width: "22px",
                    marginRight: "8px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    onSolutionAddEditAcceptanceClick(data.id, data.centre)
                  }
                />
              )}
            {data?.acceptances?.length > 0 &&
              parseInt(data?.statusId, 10) === 7 && (
                <Image
                  className="deleteImage"
                  src={getAcceptanceInfo(data.acceptances)}
                  alt={getAcceptanceText(data.acceptances)}
                  title={getAcceptanceText(data.acceptances)}
                  styles={{
                    width: "22px",
                    marginRight: "8px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    onSolutionAcceptanceClick(data.id, data.centre)
                  }
                />
              )}
          </div>
        )}
        <IDButton onClick={onSolutionIdClick}>{"#" + data.id}</IDButton>
      </DivBackgroundOpacity>
      {isSolutionViewPopupVisible && (
        <SolutionView
          onClose={onSolutionViewClose}
          id={data.id}
          onEdit={editSolution}
          isEditBtnVisible={isEditBtnVisible}
        />
      )}
      {isAddSolutionPopupVisible && (
        <AddEditSolution
          solution={currentSolution}
          id={data.id}
          onClose={closeSolutionEditPopup}
          title={`${t("UPDATE")} ${t("MATCHING")}, #${data.id}`}
          enquiryId={enquiryId}
          enquiryService={enquiryService}
          enquirySubCategoryName={enquirySubCategoryName}
          enquirySubCategoryId={enquirySubCategoryId}
          countryId={countryId}
        />
      )}
      {isViewSolutionAcceptancePopUp && (
        <SolutionAcceptanceView
          solutionId={acceptanceSolutionId}
          onClose={onCloseAcceptanceView}
          supplierName={supplierName}
          centreName={centreName}
          onSolutionEditAcceptanceClick={onSolutionEditAcceptanceClick}
          setAcceptanceId={setAcceptanceId}
          onSolutionAddAcceptanceClick={onSolutionAddAcceptanceClick}
        />
      )}
      {isAddEditSolutionAcceptancePopUp && (
        <AddEditSolutionAcceptance
          solutionId={acceptanceSolutionId}
          onClose={
            isAddSolutionAcceptanceInPopUp
              ? onCloseAddAcceptanceView
              : onCloseAddEditAcceptanceView
          }
          supplierName={supplierName}
          centreName={centreName}
          updateRefeshStatus={onRefreshData}
          isAddSolutionAcceptanceInPopUp={isAddSolutionAcceptanceInPopUp}
        />
      )}
      {isEditSolutionAcceptancePopUp && (
        <AddEditSolutionAcceptance
          solutionId={acceptanceSolutionId}
          onClose={onCloseEditAcceptanceView}
          supplierName={supplierName}
          centreName={centreName}
          isEditMode
          id={acceptanceId}
          enquiryService={enquiryService}
          enquirySubCategoryName={enquirySubCategoryName}
          enquirySubCategoryId={enquirySubCategoryId}
        />
      )}
    </SolutionIdContainer>
  );
};

SolutionId.propTypes = {
  data: PropTypes.object.isRequired,
  onRefreshData: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  enquiryService: PropTypes.string,
  enquirySubCategoryName: PropTypes.string,
  enquirySubCategoryId: PropTypes.number,
  enquiryId: PropTypes.number,
  countryId: PropTypes.number,
};
SolutionId.defaultProps = {
  enquiryService: null,
  enquirySubCategoryName: null,
  enquirySubCategoryId: null,
  enquiryId: null,
  countryId: null,
};

export default withTranslation()(SolutionId);
